import { TextField, Typography } from '@mui/material';
import { useSearchkit } from '@searchkit/client';
import { debounce } from 'lodash';
import React, { useEffect, useMemo, useRef } from 'react';
import { SkFacetSet } from 'sr-types/lib/search/v1/graphql';
import { V } from '../../../common/Layout';
import { useI18n } from '../../../common/i18n/I18n';

type TextFacetProps = {
    facet: SkFacetSet;
    autoApply?: boolean;
    onFiltersChanged?: () => void;
};

export const TextFacet = ({ facet, autoApply, onFiltersChanged }: TextFacetProps) => {
    const api = useSearchkit();
    const ref = useRef<any>(null);
    const filterValue = useMemo(() => {
        return api
            .getFiltersByIdentifier(facet.identifier)
            .map((filter) => filter.value)
            .toString();
    }, [api, facet.identifier]);
    const placeholder = useI18n('filter.search.label') + ' ' + facet.label;

    useEffect(() => {
        if (ref && ref.current && JSON.parse(sessionStorage.getItem('TextFacetActive') || 'false')) {
            ref.current.focus();
        }
    }, [filterValue]);

    const search = (filterValue) => {
        api.removeFiltersByIdentifier(facet.identifier);
        if (filterValue !== '') api.addFilter({ identifier: facet.identifier, value: filterValue });
        onFiltersChanged?.();
        if (autoApply) {
            api.search();
        }
    };

    const debouncedOnChange = debounce(search, 1000);

    const onChange = (event) => {
        debouncedOnChange(event.target.value);
        sessionStorage.setItem('TextFacetActive', 'true');
    };

    return (
        <V>
            <Typography sx={{ fontSize: 'small' }}>{facet.label}</Typography>
            <TextField
                inputRef={ref}
                id="text-facet"
                key={'textFacet'}
                placeholder={placeholder}
                variant="standard"
                fullWidth
                defaultValue={filterValue}
                onChange={onChange}
                onBlur={() => {
                    sessionStorage.setItem('TextFacetActive', 'false');
                }}
            />
        </V>
    );
};

TextFacet.DISPLAY = 'TextFacet';
